import { SelectField, SelectFieldProps } from 'components/form/final-form'
import React from 'react'

type SexoSelectFieldProps = Omit<SelectFieldProps<string>, 'items' | 'itemToString'>

export function SexoSelectField(props: SexoSelectFieldProps) {
  const itemToString = (item: SexoSelectModel) => item && descriptions[item]

  return <SelectField<SexoSelectModel> items={items} itemToString={itemToString} {...props} />
}

export type SexoSelectModel = string

const items = ['FEMININO', 'MASCULINO', 'INDETERMINADO']

const descriptions = {
  FEMININO: 'Feminino',
  MASCULINO: 'Masculino',
  INDETERMINADO: 'Indeterminado',
}
